/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import {ReferencePageType} from "./products.model";
import PropTypes from 'prop-types';

export const RecipeType = Object.assign({
    hasVideoTag: PropTypes.bool
}, ReferencePageType);


export const FavoriteRecipeType = {
    recipeId: PropTypes.string,
    recipeUrl: PropTypes.string,
};
